var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"crown-icon fas fa-crown font-size-12 shadow-text-none absolute pl-4 cursor-pointer",on:{"click":_vm.openPageSlidePopup}})
}
var staticRenderFns = []

export { render, staticRenderFns }